import { useMemo } from "react";
import { calculatorAndToolsSlugs, calculatorAndToolsResoucesLandingSlugs } from "../../utils/commonRouteUrl";
/* eslint-disable sonarjs/no-duplicate-string */

// eslint-disable-next-line import/prefer-default-export
export const useCalculatorsHook = (user_token, user_info) => {
  const isPro = useMemo(() => {
    return user_token !== undefined && (user_info?.subscription_type === "PRO" || user_info?.subscription_type === "PRO_MONTH" || user_info?.role === "Admin");
  }, [user_info?.role, user_info?.subscription_type, user_token]);

  const optimizeCalculator = useMemo(() => {
    if (isPro) {
      return calculatorAndToolsSlugs.therapistDeductionsCalculator();
    }
    return calculatorAndToolsResoucesLandingSlugs.therapistDeductionsCalculator();
  }, [isPro]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const goodFaithCalculator = useMemo(() => {
    if (isPro) {
      return calculatorAndToolsSlugs.goodFaithEstimateCalculator();
    }
    return calculatorAndToolsResoucesLandingSlugs.goodFaithEstimateCalculator();
  }, [isPro]);
  const outOfNetworkCalculator = useMemo(() => {
    if (isPro) {
      return calculatorAndToolsSlugs.outOfNetworkCalculator();
    }
    return calculatorAndToolsResoucesLandingSlugs.outOfNetworkCalculator();
  }, [isPro]);
  const optimizeLeftCalculator = useMemo(() => {
    if (isPro) {
      return calculatorAndToolsSlugs.therapistDeductionsCalculator();
    }
    return calculatorAndToolsResoucesLandingSlugs.therapistDeductionsCalculator();
  }, [isPro]);
  const goodFaithLeftCalculator = useMemo(() => {
    if (isPro) {
      return calculatorAndToolsSlugs.goodFaithEstimateCalculator();
    }
    return calculatorAndToolsResoucesLandingSlugs.goodFaithEstimateCalculator();
  }, [isPro]);
  const outOfNetworkLeftCalculator = useMemo(() => {
    if (isPro) {
      return calculatorAndToolsSlugs.outOfNetworkCalculator();
    }
    return calculatorAndToolsResoucesLandingSlugs.outOfNetworkCalculator();
  }, [isPro]);

  const optimizeRightCalculator = useMemo(() => {
    if (isPro) {
      return calculatorAndToolsSlugs.therapistDeductionsCalculator();
    }
    return calculatorAndToolsResoucesLandingSlugs.therapistDeductionsCalculator();
  }, [isPro]);
  const goodFaithRightCalculator = useMemo(() => {
    if (isPro) {
      return calculatorAndToolsSlugs.goodFaithEstimateCalculator();
    }
    return calculatorAndToolsResoucesLandingSlugs.goodFaithEstimateCalculator();
  }, [isPro]);
  const outOfNetworkRightCalculator = useMemo(() => {
    if (isPro) {
      return calculatorAndToolsSlugs.outOfNetworkCalculator();
    }
    return calculatorAndToolsResoucesLandingSlugs.outOfNetworkCalculator();
  }, [isPro]);
  const practicePaperwork = useMemo(() => {
    if (user_token) {
      return calculatorAndToolsSlugs.paperworkAndFormGenerator();
    }
    return calculatorAndToolsResoucesLandingSlugs.paperworkAndFormGenerator();
  }, [user_token]);

  const superbill = useMemo(() => {
    if (user_token) {
      return calculatorAndToolsSlugs.superbillGenerator();
    }
    return calculatorAndToolsResoucesLandingSlugs.superbillGenerator();
  }, [user_token]);

  const formBuilder = useMemo(() => {
    if (user_token) {
      return "/practice-paperwork/form/a6c164e0-f74d-4604-8aae-749f7524f0ab";
    }
    return "/resources";
  }, [user_token]);
  return [
    optimizeCalculator,
    goodFaithCalculator,
    outOfNetworkCalculator,
    optimizeLeftCalculator,
    goodFaithLeftCalculator,
    outOfNetworkLeftCalculator,
    optimizeRightCalculator,
    goodFaithRightCalculator,
    outOfNetworkRightCalculator,
    practicePaperwork,
    superbill,
    formBuilder,
  ];
};
